module.exports = __webpack_public_path__ + "img/pdf-right.89047337.png";